<div class="test-details-page">
  <div class="test-details-page__header">
    <app-test-header></app-test-header>
  </div>

  <div class="test-details">
    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">Circuit Diagram</p-tab>
        <p-tab value="1">Insulation</p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel value="0">
          <app-circuit-diagram />
        </p-tabpanel>

        <p-tabpanel value="1">
          <app-insulation />
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>

